<template>
  <a v-if="href" :href="href" :target="target" :class="buttonClass">
    <slot></slot>
  </a>
  <button v-else :class="buttonClass" @click="onClick">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    variant: {
      type: String,
      default: 'normal',
      validator: value => ['normal', 'with-arrow'].includes(value)
    },
    href: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: '_self'
    }
  },
  computed: {
    buttonClass() {
      return `button button--${this.variant}`
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  @include reset-button;
  display: inline-block;
  background-color: #007937;
  text-transform: uppercase;
  padding: rem-calc(12) rem-calc(40);
  font-family: $bold-font;
  font-weight: 900;
  font-size: rem-calc(24);
  line-height: 1.5;

  @include media-down(md) {
    padding: rem-calc(7.5) rem-calc(22);
    font-size: rem-calc(18);
    line-height: rem-calc(24);
  }

  &:hover {
    box-shadow: 1px 6px 10px 4px rgba(0, 0, 0, 0.4);
    background-color: #006930;
    color: #fff;
  }

  &--with-arrow {
    &:after {
      content: "";
      display: inline-block;
      background: url('/images/2026/arrow_2026.png') no-repeat center center;
      background-size: contain;
      margin-left: 12px;
      position: relative;
      top: 3px;
      width: rem-calc(24);
      height: rem-calc(24);
    }
  }
}
</style>
